<template>
  <!-- <div style="display: flex; flex-direction: column; gap: 10px"> -->
  <div class="m-card">
    <div class="header-surface-graph">
      <h4 class="text-w text-gray">
        <slot name="title">WC Graph</slot>
      </h4>
      <vs-spacer></vs-spacer>
      <vs-select v-model="select1" width="120px" @change="selectData">
        <vs-select-item
          :key="index"
          :value="item"
          :text="item"
          v-for="(item, index) in options1"
        />
      </vs-select>
      <!-- <vs-button
        radius
        color="success"
        type="flat"
        icon="fullscreen"
        v-if="fullscreen == false"
        @click="openFullscreen"
      ></vs-button> -->
    </div>
    <!-- <div id="chart-full">
      <div
        v-if="fullscreen"
        style="width: 100%; display: flex; justify-content: flex-end"
      >
        <vs-button
          radius
          color="success"
          type="flat"
          icon="fullscreen"
          @click="closeFullscreen"
        ></vs-button>
      </div>

      <LineChart
        :height="heightCom"
        :chartdata="chartData"
        :options="optionsChart"
        :areaColors="['#007bff']"
        :heightChart="heightChart"
        :rerender="fullscreen"
      />
    </div> -->
    <HLineChart :chart="Hchart" v-if="Hchart.series!=0"/>
    <div class="bottom-surface-graph">
      <div class="legend-box">
        <div class="legend" :style="'background-color: ' + color + ';'"></div>
        in.WC
      </div>
      <div class="bottom-right-surface-graph">
        <div class="box-chart">
          <p class="avg">avg</p>
          <p>{{ avg.toFixed(2) }} in.WC</p>
        </div>
        <div class="box-chart">
          <p class="min">min</p>
          <p>{{ min.toFixed(2) }} in.WC</p>
        </div>
        <div class="box-chart">
          <p class="max">max</p>
          <p>{{ max.toFixed(2) }} in.WC</p>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import LineChart from "@/components/ChartJs/LineChart.vue";
import HLineChart from "@/components/HighChart/LineChart.vue";

export default {
  components: {
    LineChart,
    HLineChart,
  },
  props: {
    color: String,
    dataWC: Object,
  },
  data() {
    return {
      fullscreen: false,
      height: 250,
      heightChart: 200,
      options1: ["Day", "Month", "Year"],
      select1: "Day",
      chartData: {
        datasets: [
          {
            data: [],
            label: "in.WC",
            pointBorderWidth: 1,
            borderWidth: 3,
            borderColor: this.color,
            //     backgroundColor:  this.gradient,
          },
        ],
        labels: [],
      },
      optionsChart: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
          title: {},
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              // id: "A",
              ticks: {
                // beginAtZero: true,
                // fontColor: "#ffffff",
                step: 1,
              },
              // position: "left",
              scaleLabel: {
                display: true,
                // labelString: this.chartdata.tooltip_label,
              },
            },
          ],
          // xAxes: [
          //   {
          //     // ticks: {
          //     //   // beginAtZero: true,
          //     //   fontColor: "#ffffff",
          //     // },
          //     // scaleLabel: {
          //     //   // display: true,
          //     //   // labelString: "Timestamp",
          //     // },
          //     type: 'time',
          //   },
          // ],
        },
      },
      max: 0,
      min: 0,
      avg: 0,
      Hchart: {
        chart: {
          type: "spline",
          backgroundColor: "transparent",
        },
        title: {
          text: "Vibration Sensor Graph",
          style: {
            fontSize: "0px",
          },
        },
        xAxis: {
          type: "datetime",
          // dateTimeLabelFormats: { // don't display the dummy year
          //     month: '%e. %b',
          //     year: '%b'
          // },
          title: {
            text: "Date",
          },
        },
        yAxis: {
          title: {
            text: "",
          },
          min: 0,
        },
        tooltip: {
          headerFormat: "<b>{series.name}</b><br>",
          pointFormat: "{point.x:%e. %b %H:%M}: <b>{point.y:.2f}</b> ",
        },

        plotOptions: {
          series: {
            marker: {
              enabled: true,
            },
          },
        },
        legend:{ enabled:false },

        colors: [this.color,"#fd7e14", "#20c997",  "#036", "#000"],

        // Define the data points. All series have a dummy year
        // of 1970/71 in order to be compared on the same x axis. Note
        // that in JavaScript, months start at 0 for January, 1 for February etc.
        series: [],

        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                plotOptions: {
                  series: {
                    marker: {
                      radius: 2.5,
                    },
                  },
                },
              },
            },
          ],
        },
      },
    };
  },
  computed: {
    heightCom() {
      return this.height;
      // return '100'
    },
  },
  mounted() {
    this.selectData();
  },
  methods: {
    openFullscreen() {
      // var elem = document.documentElement;
      let elem = document.querySelector("#chart-full");
      this.height = 1080;
      this.heightChart = 1000;
      // this.fullscreen = true;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Safari */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE11 */
        elem.msRequestFullscreen();
      }
      let el = document.querySelector("#chart-full");

      console.log(el.offsetHeight);
    },
    closeFullscreen() {
      let elem = document.querySelector("#chart-full");
      console.log(elem.offsetHeight);

      // this.fullscreen = false;
      this.height = 250;
      this.heightChart = 200;
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        /* Safari */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE11 */
        document.msExitFullscreen();
      }
    },
    selectData() {
      console.log(this.dataWC);
      let labels = [];
      let data = [];
      let Hdata = [];
      let max = 0;
      let min = 100;
      let sum = 0;
      this.$emit("max-min", [0, 0]);

      for (let i = 0; i < this.dataWC[this.select1.toLowerCase()].length; i++) {
        const el = this.dataWC[this.select1.toLowerCase()][i];
        labels.push(el.date);
        data.push(el.wc);
        sum += Number(el.wc);
        max = max > Number(el.wc) ? max : Number(el.wc);
        min = min < Number(el.wc) ? min : Number(el.wc);
        if (this.select1 == 'Day') {
          // console.log(el.date,el.wc);
          let split = el.date.split(' ')
          let time = split[0]+' '+split[1].slice(0,-2)+':00 '+ split[1].slice(-2)
          // console.log(time);
          // console.log(new Date(time));
          Hdata.push([new Date(time).getTime()+25200000,Number(el.wc)]);
          
        }else if (this.select1 == 'Month') {
          // console.log(el.date,el.wc);
          let split = el.date.split(' ')
          let time = split[0].slice(0,-2)+' '+split[1]+ ' '+this.$moment().format('YYYY')
          // console.log(time);
          Hdata.push([new Date(time).getTime()+25200000,Number(el.wc)]);


        }else {
          // console.log(el.date,el.wc);
          let split = el.date.split(' ')
          let time = split[0]+' '+this.$moment().format('YYYY')
          // console.log(time);
          Hdata.push([new Date(time).getTime()+25200000,Number(el.wc)]);

        }
      }
      console.log(Hdata);
      this.Hchart.series = []
      this.Hchart.series = [{
        name:'WC',
        data:Hdata
      }]
      this.max = max;
      this.min = min;
      this.avg = sum / this.dataWC[this.select1.toLowerCase()].length;
      this.$emit("max-min", [this.max, this.min]);

      // console.log(labels, data);
      this.chartData.labels = labels;
      this.chartData.datasets[0].data = data;
    },
  },
  watch: {
    dataWC: {
      // watch it
      handler(newValue, oldValue) {
        console.log("redraw chart dataWC");
        // console.log(newValue, oldValue);
        this.selectData();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.m-card {
  color: var(--text-color-2);
}
.text-w {
  font-weight: 700;
}
.header-surface-graph {
  display: flex;
  align-items: center;
}
.bottom-surface-graph {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.bottom-right-surface-graph {
  display: flex;
  align-items: center;
  gap: 10px;
}
.legend-box {
  display: flex;
  align-items: center;
  gap: 5px;
}
.legend {
  width: 30px;
  height: 15px;
  background-color: #f707ff;
  border-radius: 5px;
}
.box-chart {
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    margin: 0;
  }
}
.avg {
  font-weight: 800;
  margin-bottom: 0.5rem;
  color: #ffa807;
}
.min {
  font-weight: 800;
  margin-bottom: 0.5rem;
  color: #f707ff;
}
.max {
  font-weight: 800;
  margin-bottom: 0.5rem;
  color: #8f07ff;
}
</style>